import { CommonModule } from '@angular/common';
import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PasswordStrengthComponent } from '@nk/ui-lib';
import { SignUpService } from '../../../../services/sign-up.service';

@Component({
  selector: 'nk-sign-up-account',
  imports: [CommonModule, TranslateModule, ReactiveFormsModule, PasswordStrengthComponent],
  templateUrl: './sign-up-account.component.html',
  styleUrls: ['./sign-up-account.component.scss'],
})
export class SignUpAccountComponent implements OnInit {
  public formGroup: UntypedFormGroup;
  public showErrors = false;
  public roleTypeKeyList: string[];
  private _destroy = inject(DestroyRef);

  constructor(private _signUpService: SignUpService) {}

  public ngOnInit(): void {
    this.formGroup = this._signUpService.formUser;
    this.roleTypeKeyList = this._signUpService.roleTypeKeyList;
    this._signUpService
      .getShowError()
      .pipe(takeUntilDestroyed(this._destroy))
      .subscribe((showError) => {
        this.showErrors = showError;
      });
  }
}
